var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.51728 0.25H9.43774L13.75 4.5605V12.4827C13.75 13.1832 13.1832 13.75 12.4827 13.75H1.51728C0.816754 13.75 0.25 13.1832 0.25 12.4827V1.51728C0.25 0.816754 0.816754 0.25 1.51728 0.25ZM7.60547 1.51728H3.78604V5.14133C3.78604 5.49159 4.06942 5.77497 4.41968 5.77497H6.97183C7.32209 5.77497 7.60547 5.49159 7.60547 5.14133V1.51728ZM12.481 12.4827H1.51728V1.51728H2.51878V5.14133C2.51878 6.19035 3.37067 7.04224 4.41969 7.04224H6.97184C8.02086 7.04224 8.87275 6.19035 8.87275 5.14133V1.51728H8.91323L12.481 5.08501V12.4827ZM6.88384 3.87409C6.88384 4.22435 6.60046 4.50772 6.2502 4.50772C5.89994 4.50772 5.61656 4.22435 5.61656 3.87409V3.11724C5.61656 2.76698 5.89994 2.4836 6.2502 2.4836C6.60046 2.4836 6.88384 2.76698 6.88384 3.11724V3.87409Z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.c8dff008.svg";
export { ForwardRef as ReactComponent };